'use strict';

import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import AnalyticsSources from '../constants/AnalyticsSources';
import SidebarTypes from '../constants/SidebarTypes';
import handleUnauthAction from '../utils/handleUnauthAction';
import assign from 'react/lib/Object.assign';
import invariant from 'react/lib/invariant';

function needsAuthentication(id) {
  switch (id) {
  case SidebarTypes.PINTEREST_PICKER:
  case SidebarTypes.STAMP_OTHER_ZINES:
  case SidebarTypes.STAMP_LIKES:
  case SidebarTypes.USER_SUBSCRIPTIONS:
  case SidebarTypes.USER_SUBSCRIBERS:
  case SidebarTypes.IMAGE_USED_IN_STAMPS:
    return false;
  }

  return true;
}

const SidebarActionCreators = {
  showSidebar(id, options) {
    invariant(
      SidebarTypes.hasOwnProperty(id),
      'showSidebar() accepts a constant from SidebarTypes. You passed %s',
      id
    );

    if (needsAuthentication(id) && handleUnauthAction(AnalyticsSources.SHOW_SIDEBAR)) {
      return;
    }

    AppDispatcher.handleViewAction({
      type: ActionTypes.SHOW_SIDEBAR,
      sidebar: assign({ id: id }, options)
    });
  },

  hideSidebar() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.HIDE_SIDEBAR
    });
  }
};

export default SidebarActionCreators;



/** WEBPACK FOOTER **
 ** ./actions/SidebarActionCreators.js
 **/